import { PlatformAdminApi, plt } from 'src/services/GrpcService';
import { IOrderCost } from '../../../orders/pages/order-view/interfaces/payments';
import {
  GetAvailableTabsResponse,
  ICreateOrderRequest,
  ICreateOrderResponse,
} from '../../../orders/pages/order-view/providers/interface';

export interface IUserOrdersServiceProvider {
  retrieveOrders(req: IRetrieveOrdersRequest): Promise<IAdaptedOrdersList>;
  createOrder(req: ICreateOrderRequest): Promise<ICreateOrderResponse>;
  getAvailableTabs(): Promise<GetAvailableTabsResponse>;
}

export interface IUuidRequest {
  id: string;
}

export interface IRetrieveOrdersRequest {
  userId: string;
  page?: number | null;
  limit?: number | null;
  statuses?: plt.core.base.ORDER_STATUS_TYPE[];
}

export interface IOrderCart {
  cartId?: null | string;
  serialNumber?: null | number;
  createdAt?: null | string;
  updatedAt?: null | string;
  deletedAt?: null | string;
  status?: null | OrderCartStatus;
  isFirstOrderInCart?: null | boolean;
  ordersCount?: null | number;
}

export enum OrderCartStatus {
  Created = 0,
  Confirmed = 1,
  Completed = 2,
  Canceled = 3,
  Unknown = 4,
}

export interface IOrderItem {
  orderId?: null | string;
  serialNumber?: null | number;
  title?: null | string;
  startDate?: null | string;
  timeZone?: null | string;
  completedAt?: null | string;
  options?: null | IOrderOption[];
  remainingOptionsCount?: null | number;
  statusName?: string | null;
  statusCategory?: OrderStatusCategory | null;
  isExternal?: boolean | null;
  externalDetailsPageUrl?: string | null;
  customerId?: string | null;
  orderMeta?: PlatformAdminApi.ICustomerOrderMeta | null;
  rejectionReason?: PlatformAdminApi.IRejectionReason | null;
  pickUp?: PlatformAdminApi.ICustomerAssignmentItem | null;
  deliveries?: PlatformAdminApi.ICustomerAssignmentItem[] | null;
  paymentStatus?: plt.core.base.PAYMENT_STATUS_TYPE | null;
}

export enum OrderStatusCategory {
  Confirmed = 0,
  InProgress = 1,
  Completed = 2,
  Canceled = 3,
  Unknown = 4,
  Draft = 5,
  OnCoordination = 6,
  WaitInPickPoint = 7,
}

interface IOrderOption {
  name?: null | string;
  value?: null | number;
  factor?: null | number;
  totalPrice?: null | number;
}

export interface IOrderAddress {
  city?: null | string;
  metroStations?: null | IMetro[];
  value?: null | string;
  coordinates?: null | {
    lat?: number | null;
    lng?: number | null;
  };
  type?: PlatformAdminApi.ADDRESS_TYPE | null;
}

export interface IMetro {
  name?: null | string;
  color?: null | string;
}

export interface IAssignmentWaypoint {
  type?: PlatformAdminApi.CustomerAssignmentWaypointType | null;
}

export interface IAssignmentItem {
  contractor?: null | IAssignmentItemContractor;
  status?: null | OrderAssignmentStatus;
  startAt?: null | string;
  endAt?: null | string;
  waypoint?: IAssignmentWaypoint | null;
}

export interface IAssignmentItemContractor {
  id?: null | string;
  type?: null | string;
  fullName?: null | string;
}

export enum OrderAssignmentStatus {
  Waiting = 0,
  Confirmed = 1,
  Rejected = 2,
  AtWork = 3,
  Done = 4,
}

export interface IOrdersListItem {
  cart?: null | IOrderCart;
  address?: null | IOrderAddress;
  order?: null | IOrderItem;
  assignments?: null | IAssignmentItem[];
  cost?: null | IOrderCost;
}

export interface IUserOrdersListResponse {
  data: IOrdersListItem[];
  page: number;
  limit: number;
  total: number;
}

export interface IAdaptedOrdersList extends IUserOrdersListResponse {
  data: Array<IOrdersListItem & { order: IOrderItem & { timeZone: string } }>;
}

export interface IUserOrdersPagination {
  page: number;
  limit: number;
  total?: number | null;
}
